import React, { Component } from 'react';
import { BounceLoader, ClipLoader } from 'react-spinners';
import '../css/Loading.css';

const $ = window.$;

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state={ loading: this.props.show }
  }

  componentDidMount() {
    if ( this.state.loading ) {
      $('#loading').css("display", "block");
      $('html').css("overflow", "hidden");
    } else {
      $('#loading').css("display", "none");
      $('html').css("overflow", "unset");
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ loading: nextProps.show }); 
    if ( nextProps.show ) {
      $('#loading').css("display", "block");
      $('html').css("overflow", "hidden");
    } else {
      $('#loading').css("display", "none");
      $('html').css("overflow", "unset");
    }
  }

  render() {
    return (
      <div>
        <div className='sweet-loading' id="loading">
          <div className="loading-content">
            <ClipLoader color={'#ffffff'} loading={this.state.loading}></ClipLoader>
            <div className="loading-text">กรุณารอซักครู่..</div>          
          </div>
        </div>
      </div>
    )
  }
}

export default Loading;